import { EMPTY_DATA_PLACEHOLDER } from "@/utils/constants"

export const getStringValue = (value: unknown): string | null => {
  if (typeof value === "string") {
    return value
  }

  if (typeof value === "number") {
    return String(value)
  }

  return null
}

export const getDisplayValue = (
  value: string | number | null | undefined
): string => {
  const normalized = getStringValue(value)?.trim() ?? ""

  return normalized === "" ? EMPTY_DATA_PLACEHOLDER : normalized
}

export const getDisplayListValue = (
  values: readonly string[],
  separator = ", "
): string => getDisplayValue(values.join(separator))
